import React, { useEffect, useState, useContext, useCallback } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { work_spaceActions, organizationActions } from '../../../actions';
import { Button, Table, Row, Col, Dropdown, ProgressBar, Image } from 'react-bootstrap';
import {
  Popup,
  SortIcon,
  CircleAddIcon,
  LoadSpinner,
  BasicSpinner,
  OrganizationInlineEdit
} from '../../../components';
import WorkSpaceNew  from '../WorkSpacePage/new';
import OrganizationNew from '../OrganizationPage/new';
import Sidebar from './sidebar';
import { WorkspaceListContext } from '../../../contexts/WorkspaceListContext';
import MoreVertival from '../../../images/icons/more-vertical.svg';
import { buildFormDataFromObject } from '../../../utils/commonUtils';
import { TopbarContext } from '../../../contexts/TopbarContext';
import NotificationPage from '../NotificationPage/list';
import useLeaveWorkspaceHooks from '../../../hooks/useLeaveWorkspaceHooks';
import { sidebarConstants } from '../../../constants/sidebar.constants';
import useSidebarHook from '../../../hooks/useSidebarHook';
import SortedWorkspace from '../../../components/workspace_list/SortedWorkspaces';
import SubscriptionPanel from '../../../components/subscriptions/SubscriptionPanel';
import WorkspaceFileLimitBar from 'components/workspace/WorkspaceFileLimitBar';

function WorkSpaceList(props) {
  const dispatch = useDispatch();
  const {
          organizations,
          work_spaces,
          can_crud_workspace,
          initialData,
          can_create_workspace,
          can_create_organization,
          can_update_organization,
          can_destroy_organization,
          current_organization,
          workspace_loading,
          loading
        } = props
  const location = useLocation();
  const { organization_id } = useParams();

  const default_modes = sidebarConstants.DEFAULT_MODES
   
  const { selected_organization, selected_tab } = useSelector(state => state.sidebar);
  const [organization_new_form_popup, setOpenOrganizationNewFormPopup] = useState({ show: false });
  const [organization_destroy_popup, setOpenOrganizationDestroyPopup] = useState({ id: null, show: false });
  const { setIsHomePage } = useContext(TopbarContext);

  // ----- Hooks ----- //
  const {} = useLeaveWorkspaceHooks();
  const {} = useSidebarHook({});

  const is_notification_selected = selected_tab === default_modes[3];

  const handleOpenOrganizationNewPopup = () => {
    setOpenOrganizationNewFormPopup({ show: true })
  }

  const handleCloseOrganizationNewPopup = () => {
    setOpenOrganizationNewFormPopup({ show: false })
  }

  const handleOpenOrganizationDeletePopup = (id) =>{
    setOpenOrganizationDestroyPopup({ show: true, id: id });
  }

  const handleCloseOrganizationDeletePopup = () =>{
    setOpenOrganizationDestroyPopup({ show: false, id: null });
  }

  const handleDeleteOrganization = () => {
    const successCallback = () => {
      window.location = '/'
    }

    dispatch(organizationActions.destroyOrganization(organization_destroy_popup.id, successCallback));
  }

  const sort_options =[
    "recently",
    "alphabetically"
  ];

  useEffect(() => {
    setIsHomePage(true);
  }, []);
  

  useEffect(() => {
    dispatch(organizationActions.getOrganizations())
  }, [location]);


  /*
    Popup New Form Modal

  */

  const [popupNewForm, setPopUpNewForm] = useState({
    show: false
  });;

  const handleCloseNewForm = () => {
    setPopUpNewForm({ show: false });
  }

  const handleShowNewForm = () => {
    dispatch(work_spaceActions.workspaceInitial(setPopUpNewForm));
  }

  /*
    Sort Workspaces
  */

  let sorted_workspaces = [];

  const [sortValue, setSortValue] = useState(sort_options[1]);

  switch(sortValue){
    case sort_options[0]:
      sorted_workspaces = work_spaces ?
        work_spaces.sort((a, b) =>
          new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
        )
      :
        [];
      break;

    case sort_options[1]:
      sorted_workspaces = work_spaces ?
        work_spaces.sort((a, b) =>
          a.name.localeCompare(b.name)
        )
      :
        [];
      break;

    default:
      sorted_workspaces = work_spaces;
  }

  const handleWorkspaceSort = () =>{
    if(sortValue === sort_options[0]){
      setSortValue(sort_options[1])
    } else{
      setSortValue(sort_options[0])
    }
  }

  let hasWorkspace = sorted_workspaces && sorted_workspaces.length > 0;

  const renderActiveOrganizationTitle = () =>{
    if(selected_tab === default_modes[0]){
      return <h2
                className="organization_title font-weight-bold text-truncate mb-0"
             >
                My Workspace
             </h2>
    } 
    
    if(selected_tab === default_modes[3]){
      return <h2
                className="organization_title font-weight-bold text-truncate mb-0"
             >
                Notifications
             </h2>
    } 

    if(current_organization){

      if(can_update_organization){
        return <OrganizationInlineEdit
                  organization_title={current_organization?.name}
                  handleInlineEdit={handleOrganizationInlineEdit}
                  organization_id={current_organization?.id}
                />
      } else {
        return <h2
                  className="organization_title font-weight-bold text-truncate"
               >
                  {
                    current_organization?.personal && current_organization?.owner ?
                      "My Workspace"
                    :
                      current_organization?.name
                  }
               </h2>
      }
    }

    if (selected_tab === 'shared'){
      return <h2
                className="organization_title font-weight-bold text-truncate"
             >
                Shared
             </h2>
    }

    // TODO: Find Organization Name here using selected_organization_id

    return <h2
              className="organization_title font-weight-bold text-truncate"
           >
              Workspaces
           </h2>
  }

  const handleOrganizationInlineEdit = (organization_id, values) => {
    let formData = new FormData();
    buildFormDataFromObject(formData, values, "organization");

    const successCallback = () =>{
      dispatch(organizationActions.getOrganizations());
      dispatch(organizationActions.getWorkspaces(organization_id));
    }

    dispatch(organizationActions.updateOrganization(organization_id, formData, successCallback));
  }

  let workspaceListContext = {
    handleOpenOrganizationNewPopup: handleOpenOrganizationNewPopup,
    handleShowNewForm
  } 
  

  if (props.loading) {
    return <LoadSpinner />
  }

  return (
    <div className="container-lg layout__container-wrapper" style={{ height: "100%" }}>
      <WorkspaceListContext.Provider value={workspaceListContext}>
        <div className="col-lg-12">
          <Row className="p-3">
            <Col lg={3} className="d-none d-lg-block">
              <Sidebar/>
            </Col>
            <Col lg={9} className="pl-lg-12">
              
              {
                !is_notification_selected &&

                <Row className="mb-3 g-0">
                  <Col
                    sm={12}
                    lg={can_create_workspace && sorted_workspaces.length > 1 ? 5 : 8}
                    className={"d-flex align-items-center pl-0"}
                  >
                    {renderActiveOrganizationTitle()}

                    {
                      false && can_destroy_organization && current_organization &&
                      <Dropdown className="align-self-center d-inline-block">
                        <Dropdown.Toggle variant="primary" id="dropdown-basic" className="btn-transparent d-flex align-items-center" title="Options">
                          <img src={MoreVertival} height={'16'}/>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{right: "auto"}}>
                          <Button
                            variant="secondary"
                            className="dropdown-item"
                            onClick={() => handleOpenOrganizationDeletePopup(current_organization.id)}
                          >
                            Delete
                          </Button>
                        </Dropdown.Menu>
                      </Dropdown>
                    }
                  </Col>


                  <Col sm={12} lg={can_create_workspace && sorted_workspaces.length > 1 ? 7 : 4} className="workspace_button-group d-flex justify-content-end">
                    {can_create_workspace && hasWorkspace && (
                      <Button
                        onClick={handleShowNewForm}
                        className="btn btn-primary d-flex align-items-center ml-4"
                      >
                        <CircleAddIcon
                          color={"#fff"}
                          height={"14"}
                          width={"14"}
                          className="mr-4"
                        />
                        Add Workspace
                      </Button>
                    )}
                    { hasWorkspace && sorted_workspaces.length > 1 &&
                      <select className="form-select d-none" onChange={(e) => setSortValue(e.target.value)} defaultValue={sortValue} style={{display: 'inline-block', width: 'auto'}}>
                        <option value={sort_options[0]}>Recently Updated</option>
                        <option value={sort_options[1]}>A-Z</option>
                      </select>
                    }
                    {
                      hasWorkspace && sorted_workspaces.length > 1 &&
                      <Button
                        variant={sortValue === sort_options[0] ? "primary" : "light"}
                        className="ml-4 d-flex align-items-center"
                        onClick={handleWorkspaceSort}
                      >

                        <SortIcon
                          color={sortValue === sort_options[0] ? "#fff" : "#727580"}
                          height={'14'}
                          width={'14'}
                          className={'mr-4'}
                        />
                        Recently Updated
                      </Button>
                    }
                  </Col>
                </Row>
              }

              <Row>
                 <SubscriptionPanel />
                {
                  selected_tab === default_modes[3] ?
                  <NotificationPage /> :
                  <SortedWorkspace sorted_workspaces={sorted_workspaces} />
                }

                {workspace_loading &&
                  <Col sm={12} className={"pl-0"}>
                    <BasicSpinner />
                  </Col>
                }

                {
                  current_organization?.personal == false && workspace_loading == false &&
                  <Col className='px-0 mt-3'>
                    <WorkspaceFileLimitBar workspace={current_organization} className='' lg />
                  </Col>                  
                } 
              </Row>
            </Col>
          </Row>
        </div>


        {
          popupNewForm.show &&
          <WorkSpaceNew
            initialData={initialData}
            handleCloseNewForm={handleCloseNewForm}
          />
        }

        {
          organization_new_form_popup.show &&
          <OrganizationNew
            handleCloseForm={handleCloseOrganizationNewPopup}
          />
        }

        {/* Organization Delete Popup */}
        {organization_destroy_popup.show &&
          <Popup
            handleClose={handleCloseOrganizationDeletePopup}
            handleDelete={handleDeleteOrganization}
          />
        }
      </WorkspaceListContext.Provider>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.work_space.loading,
    can_crud_workspace: state.work_space.can_crud_workspace,
    work_spaces: state.work_space.work_spaces,
    initialData: state.work_space.initialData,
    error: state.work_space.error,
    can_create_workspace: state.organization.can_create_workspace,
    can_create_organization: state.organization.can_create_organization,
    can_update_organization: state.organization.can_update_organization,
    can_destroy_organization: state.organization.can_destroy_organization,
    workspace_loading: state.work_space.workspace_dropdown_loading,
    organizations: state.organization.organizations,
    current_organization: state.organization.current_organization
  };
};

export default connect(mapStateToProps, { work_spaceActions })(WorkSpaceList);
